import script from "./HeaderWarnings.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderWarnings.vue?vue&type=script&setup=true&lang=js"

import "./HeaderWarnings.vue?vue&type=style&index=0&id=683ada40&lang=css"

const __exports__ = script;

export default __exports__